<template>
    <div class="first_step-container">
        <h1>{{translate("select_fan_type")}}</h1>
        <div class="elements-container">
            <first-step-element v-for="element in getFirstStepElements"
                                :id="element.id"
                                :key="element.id"
                                :name="element.title_translation_code"
                                :img-src="element.imgSrc"
                                :img-clicked="element.imgClicked"
                                :description="element.description_translation_code"
                                :default_minimum_material_density="element.default_minimum_material_density"
                                :default_minimum_material_density_value="element.default_minimum_material_density_value"
                                :delta_t_condition_check="element.delta_t_condition_check"
                                v-if="!element.admin_only || isAdmin"
            >
            </first-step-element>
            <div class="element" @click="showModal">

                <div class="img-container name-container request">
                    <span class="text">{{translate('send_your_request')}}</span>
                </div>

                <div class="expandable_text-container expandable_request"
                     :class="{hidden : isExpanded}">
                    <span class="text">{{translate('question_message_main')}}</span>
                </div>
            </div>
            <third-step-modal-mail v-if="isModalVisible"
                                   @close="closeModal"
                                   :target="'fan'">
            </third-step-modal-mail>
        </div>
    </div>
</template>

<script>
    import FirstStepElement from '@/components/configuration_steps/firstStep/FirstStepElement.vue'
    import ThirdStepModalMail from "../thirdStep/ThirdStepModalMail";

    export default {
        name: "FirstStep",
        components: {ThirdStepModalMail, FirstStepElement},
        data() {
            return {
                isExpanded: false,
                isModalVisible: false
            }
        },
        computed: {
            isAdmin() {
                return this.$store.getters.getUserRole == 'admin'
            },
            getFirstStepElements() {
                return this.$store.state.firstStepElements;
            }
        },
        methods: {
            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;

            },

            showModal() {
                this.isModalVisible = true;
            },

            closeModal() {
                this.isModalVisible = false;
            },

            compare(a, b) {
                // Use toUpperCase() to ignore character casing
                const bandA = this.translate(a.title_translation_code).toUpperCase();
                const bandB = this.translate(b.title_translation_code).toUpperCase();

                return bandA.localeCompare(bandB);
            },

            loadElements(elements) {
                this.$store.state.firstStepElements = [];

                for (let item of elements) {
                    let firstStepElement = {
                        id: item['id'],
                        title_translation_code: item['title_translation_code'],
                        imgSrc: item['image'],
                        imgClicked: item['image_clicked'],
                        description_translation_code: item['description_translation_code'],
                        default_minimum_material_density_value: item['default_minimum_material_density_value'],
                        default_minimum_material_density: item['default_minimum_material_density'],
                        delta_t_condition_check: item['delta_t_condition_check'],
                        admin_only: item['admin_only'] == 1,
                    };

                    this.$store.state.firstStepElements.push(firstStepElement);
                }
                this.$store.state.firstStepElements.sort(this.compare);
            },
        },
        beforeMount() {
            this.$apiController.getFanTypeList().then(
                function (response) {
                    if (response && response['status'] && response['status'] == "success" && response['data']) {
                        this.loadElements(response['data']);
                    }
                }.bind(this)
            );
        },
        mounted() {
            // NVS-92 Reset temperatury do domyślnej
            this.$store.state.fourthStepParameters.temperature.value = this.$store.state.fourthStepParameters.temperature.defaultValue;
            this.$store.state.fourthStepParameters.temperature.oryginal = null;
        }
    }
</script>
